const FolderWorkflowTypeConstant = {
  'POWER_TOOLS': 'POWER_TOOLS',
  'GENERIC': 'GENERIC'
}

export default FolderWorkflowTypeConstant;
